const getCurrency = (availableCurrencies, currency_id) => {
  return availableCurrencies.find((item) => +item.value === +currency_id);
};

export { getCurrency };
